import {MutationTree} from "vuex";
import {ModerationTemplatesState} from "@/store/user_management/template_moderation/types";

export const mutations: MutationTree<ModerationTemplatesState> = {
  setModerationTemplates: (state, payload) => {
    state.moderationTemplates = payload
  }
}